export default "__VITE_ASSET__Bp4r8$tq__"